<template>
    <b-modal
        ref="modal"
        :visible="showLoading"
        size="sm"
        modal-class="loading-modal"
        hide-header-close
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
        no-fade>
        <b-container
            fluid
            class="text-center">
            <b-row>
                <b-col>
                    <div
                        data-test-ref="attached-app-loader"
                        class="loader">
                        <loading></loading>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
export default {
    name: 'LoadingModal',
    props: {
        showLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        visible() {
            return this.$refs.modal.is_visible;
        }
    },
    methods: {
        /**
         * Show the loading modal
         */
        show() {
            this.$refs.modal.show();
        },
        /**
         * Hide the loading modal
         */
        hide() {
            this.$refs.modal.hide();
        }
    }
};
</script>

<style>
    .loading-modal .modal-content {
        background-color: transparent;
        border: 0px solid transparent;
    }
    .loading-modal {
        z-index: 9999;
    }
</style>
